import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    enrolledCourses: {},
    coursesEnrolled: []
};

const getters = {
    allEnrolledCourses(state) {
        return function () {
            return state.coursesEnrolled
        }
    }
};

const actions = {
    getCoursesEnrolled({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            axios.get(api.getCoursesEnrolled())
                .then((data) => {
                    const courses = data.data.results;

                    commit(types.SET_COURSES_ENROLLED, courses);

                    resolve(courses);
                })
                .catch(({response}) => reject(response))
                .done();
        });
    },

    /**
     * Get member course progress.
     *
     * @param commit
     * @param state
     * @param courseSlug
     * @returns {Promise}
     */
    getCourseProgress({commit, state}, {courseSlug}) {
        return new Promise((resolve, reject) => {
            /**
             * If we've already fetched enrolled course then we should load from caching.
             */
            if (state.enrolledCourses[courseSlug]) {
                const memberCourse = state.enrolledCourses[courseSlug];

                if (!memberCourse.isActive && !memberCourse.completedAt) {
                    return reject({data: {isActive: false}})
                }

                return resolve({cache: true});
            }

            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getCourseProgress(courseSlug))
                .then(({data}) => {
                    const memberCourse = data.memberCourse.data;
                    const course = data.course.data;

                    if (!memberCourse.isActive && !memberCourse.completedAt) {
                        return reject({data: {isActive: false}})
                    }

                    commit(types.UPDATE_ENROLLED_COURSE, {courseSlug, memberCourse});
                    commit('course/UPDATE_COURSES_CONTENT', {courseSlug, courseData: course}, {root: true});

                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.UPDATE_ENROLLED_COURSE](state, {courseSlug, memberCourse}) {
        state.enrolledCourses = {...state.enrolledCourses, [courseSlug]: memberCourse};
    },

    [types.SET_COURSES_ENROLLED](state, data) {
        state.coursesEnrolled = data;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};